import React, {useEffect, useState} from "react";
import {ApartmentOutlined, FullscreenOutlined} from "@ant-design/icons";
import PageHead from "../../layout/PageHead";
import {ROUTES} from "../../../config/consts/routes";
import {SECTIONS} from "../../../config/constants";
import {useTranslation} from "react-i18next";
import {Button, Input, Select, Space} from "antd";
import "./Dashboard.css";
import {useSelector} from "react-redux";
import ReportService from "../../../services/report/ReportService";

const routes = [
  {
    path: ROUTES.general.main.route,
    breadcrumbName: SECTIONS.general.name,
  }
];

const Dashboard = () => {
  const {
    profile,
    report
  } = useSelector((state: any) => ({
    profile: state.profile,
    report: state.report
  }));
  
  const { t, i18n } = useTranslation("translations");
  
  const [softSelectedReport, setSoftSelectedReport] = useState<any>();

  const [groupCodes, setGroupCodes] = useState<any>([]);
  const [entities, setEntities] = useState<any>([]);
  const [operations, setOperations] = useState<any>([]);
  const [reports, setReports] = useState<any>([]);
  
  const [selectedGroupCode, setSelectedGroupCode] = useState<any>();
  const [selectedEntity, setSelectedEntity] = useState<any>();
  const [selectedOperation, setSelectedOperation] = useState<any>();
  const [selectedReport, setSelectedReport] = useState<any>();
  
  const [currentReport, setCurrentReport] = useState<any>();
  
  useEffect(() => {
    document.title = ROUTES.administration.account.name;
  }, []);

  useEffect(() => {
    ReportService.getAll().then((response: any) => {
      const data = response.data;
      setReports(data);
    });
  }, []);
  
  useEffect(() => {
    document.title = "DATAshaper";
  }, []);

  useEffect(() => {
    if (selectedReport) {
      setCurrentReport(reports.find((x: any) => x.id === selectedReport));
    } else {
      if (reports && reports.length > 0) {
        setCurrentReport(reports[0]);
      }
    }
  }, [selectedReport]);
  
  const openFullScreen = () => {
    const iframe = document.getElementById("powerbi-iframe") as HTMLIFrameElement;
    if (iframe?.requestFullscreen) {
      iframe.requestFullscreen();
    } else if ((iframe as any).mozRequestFullScreen) {
      (iframe as any).mozRequestFullScreen(); // Firefox
    } else if ((iframe as any).webkitRequestFullscreen) {
      (iframe as any).webkitRequestFullscreen(); // Chrome, Safari, Opera
    } else if ((iframe as any).msRequestFullscreen) {
      (iframe as any).msRequestFullscreen(); // IE/Edge
    }
  }

  const actionButton = (
      <Space>
        {selectedReport && (
            <Button
                type="primary"
                onClick={openFullScreen}
                icon={<FullscreenOutlined />}
            >
              {t("Page.Dashboard.Labels.Fullscreen", {
                lngs: i18n.languages,
                defaultValue: "Fullscreen",
              })}
            </Button>
        )}
      </Space>
  );

  return <div>
    <PageHead
        title={t("Page.Dashboard.Headers.Dashboard", {
          lngs: i18n.languages,
          defaultValue: "Dashboard",
        })}
        icon={<ApartmentOutlined />}
        routes={routes}
        groupCodes={groupCodes}
        entities={entities}
        operations={operations}
        reports={reports}
        selectedGroupCode={selectedGroupCode}
        selectedEntity={selectedEntity}
        selectedOperation={selectedOperation}
        selectedReport={selectedReport}
        setSelectedGroupCode={setSelectedGroupCode}
        setSelectedEntity={setSelectedEntity}
        setSelectedOperation={setSelectedOperation}
        setSelectedReport={setSelectedReport}
        setSelectGroupCodeDisabled={false}
        setSelectEntityDisabled={false}
        setSelectOperationDisabled={false}
        mainAction={actionButton}
        otherActions={[]}
        setActionsDisabled={false}
        showBackArrow={false}
        showGroupCodes={false}
        showOperations={false}
        showEntities={false}
        showReports={true}
    />
    <div className="dashboard-body-container" style={{height: "calc(90vh - 8em)"}}>
      {currentReport && (
          <div style={{height: '100%', width: '100%'}}>
            <iframe id="powerbi-iframe"
                    title={currentReport?.name} style={{width: '100%', height: '100%'}}
                    src={`${currentReport?.url}&rs:Embed=true`}
                    frameBorder="0" allowFullScreen={true}></iframe>
          </div>
      )}
    </div>
  </div>;
};

export default Dashboard;
